(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-shipping-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-shipping-calculator')) {
    customElements.define('product-shipping-calculator', class ProductShippingCalculator extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="postal_code"]');
        this.status = this.querySelector('[role="status"]');
        this.result = this.querySelector('[data-result]');

        this.input.addEventListener('input', () => {
          const digits = this.input.value.replace(/\D/g, '').slice(0, 8);
          this.input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
          this.status.textContent = '';
          this.status.classList.remove('is-error');
          this.result.hidden = true;
        });

        this.form.addEventListener('submit', (event) => {
          event.preventDefault();
          const digits = this.input.value.replace(/\D/g, '');

          if (digits.length !== 8) {
            this.status.textContent = this.dataset.invalidMessage;
            this.status.classList.add('is-error');
            this.result.hidden = true;
            this.input.focus();
            return;
          }

          this.status.textContent = this.dataset.successMessage;
          this.status.classList.remove('is-error');
          this.result.hidden = false;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
